export const state = {
  incidents: [],
  masters: [],
};

export const getters = {
  incidents: (state) => state.incidents,
  masters: (state) => state.masters
};

export const mutations = {
  updateIncidents (state, incidentsArray) {
    state.incidents = incidentsArray;
  },
  setMasters (state, masters) {
    state.masters = masters;
  },
};

export const actions = {
  updateIncidents ({ commit }, incidentsArray) {
    commit("updateIncidents", incidentsArray);
  },
  setMasters ({ commit }, masterData) {
    commit("setMasters", masterData);
  },
};
